import { render, staticRenderFns } from "./DiscountTag.vue?vue&type=template&id=4fa1aaa8&scoped=true&"
import script from "./DiscountTag.vue?vue&type=script&lang=js&"
export * from "./DiscountTag.vue?vue&type=script&lang=js&"
import style0 from "./DiscountTag.vue?vue&type=style&index=0&id=4fa1aaa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa1aaa8",
  null
  
)

export default component.exports